/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Cancellation_Period_HintInputs */

const en_admin_allocation_form_cancellation_period_hint = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of months notice required before ending this allocation. If left blank, the allocation can be canceled to the end of the current billing cycle.`)
};

const de_admin_allocation_form_cancellation_period_hint = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Monate, die vor Beendigung dieser Zuweisung als Kündigungsfrist erforderlich sind. Wenn leer gelassen, kann die Zuweisung zum Ende des aktuellen Abrechnungszyklus gekündigt werden.`)
};

const es_admin_allocation_form_cancellation_period_hint = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de meses de aviso requerido antes de finalizar esta asignación. Si se deja en blanco, la asignación puede cancelarse al final del ciclo de facturación actual.`)
};

const fr_admin_allocation_form_cancellation_period_hint = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de mois de préavis requis avant de mettre fin à cette attribution. Si laissé vide, l'attribution peut être résiliée à la fin du cycle de facturation en cours.`)
};

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */
const it_admin_allocation_form_cancellation_period_hint = en_admin_allocation_form_cancellation_period_hint;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_cancellation_period_hint = en_admin_allocation_form_cancellation_period_hint;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */
const pl_admin_allocation_form_cancellation_period_hint = en_admin_allocation_form_cancellation_period_hint;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */
const hu_admin_allocation_form_cancellation_period_hint = en_admin_allocation_form_cancellation_period_hint;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Period_HintInputs) => LocalizedString} */
const ro_admin_allocation_form_cancellation_period_hint = en_admin_allocation_form_cancellation_period_hint;

/**
* | output |
* | --- |
* | "Number of months notice required before ending this allocation. If left blank, the allocation can be canceled to the end of the current billing cycle." |
*
* @param {Admin_Allocation_Form_Cancellation_Period_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_cancellation_period_hint = /** @type {((inputs?: Admin_Allocation_Form_Cancellation_Period_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Cancellation_Period_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_cancellation_period_hint(inputs)
	if (locale === "de") return de_admin_allocation_form_cancellation_period_hint(inputs)
	if (locale === "es") return es_admin_allocation_form_cancellation_period_hint(inputs)
	if (locale === "fr") return fr_admin_allocation_form_cancellation_period_hint(inputs)
	if (locale === "it") return it_admin_allocation_form_cancellation_period_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_cancellation_period_hint(inputs)
	if (locale === "pl") return pl_admin_allocation_form_cancellation_period_hint(inputs)
	if (locale === "hu") return hu_admin_allocation_form_cancellation_period_hint(inputs)
	return ro_admin_allocation_form_cancellation_period_hint(inputs)
});
export { admin_allocation_form_cancellation_period_hint as "admin.allocation_form.cancellation_period_hint" }